import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.54,10.79V9.21a0.8,0.8,0,0,0-.79-0.79H11.58V5.25a0.8,0.8,0,0,0-.79-0.79H9.21a0.8,0.8,0,0,0-.79.79V8.42H5.25a0.8,0.8,0,0,0-.79.79v1.58a0.8,0.8,0,0,0,.79.79H8.42v3.17a0.8,0.8,0,0,0,.79.79h1.58a0.8,0.8,0,0,0,.79-0.79V11.58h3.17A0.8,0.8,0,0,0,15.54,10.79Zm4-.79a9.29,9.29,0,0,1-1.27,4.77,9.46,9.46,0,0,1-3.46,3.46A9.29,9.29,0,0,1,10,19.5a9.29,9.29,0,0,1-4.77-1.27,9.46,9.46,0,0,1-3.46-3.46A9.29,9.29,0,0,1,.5,10,9.29,9.29,0,0,1,1.77,5.23,9.46,9.46,0,0,1,5.23,1.77,9.29,9.29,0,0,1,10,.5a9.29,9.29,0,0,1,4.77,1.27,9.46,9.46,0,0,1,3.46,3.46A9.29,9.29,0,0,1,19.5,10Z"
});

var SvgPlusCircle = function SvgPlusCircle(props) {
  return _ref;
};

export default SvgPlusCircle;